import React, { Component } from 'react';
import { useTranslation } from 'react-i18next';
import "./Messages.css";

const withTranslation = (Component) => {
  return (props) => {
    const { t } = useTranslation();
    return <Component {...props} t={t} />;
  };
};

class MessageItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editMode: false,
      editText: this.props.message.text,
    };
  }

  onToggleEditMode = () => {
    this.setState(state => ({
      editMode: !state.editMode,
      editText: this.props.message.text,
    }));
  };

  onChangeEditText = event => {
    this.setState({ editText: event.target.value });
  };

  onSaveEditText = () => {
    this.props.onEditMessage(this.props.message, this.state.editText, this.props.authUser);

    this.setState({ editMode: false });
  };

  render() {
    const { authUser, message, onRemoveMessage } = this.props;
    const { editMode, editText } = this.state;
    const { t } = this.props;

    const formatTimestamp = (timestamp) => {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return 'just now';
      if (diffMins < 60) return `${diffMins}m ago`;
      if (diffHours < 24) return `${diffHours}h ago`;
      if (diffDays < 7) return `${diffDays}d ago`;
      return date.toLocaleDateString();
    };

    const getUserIcon = (userPhoto) => {
      // If user has photo, show first letter + 💬 emoji, otherwise just 💬
      return '💬';
    };

    return (
      <div className='message-item'>
        <span className="message-icon">
          {message.userPhoto ? (
            <img src={message.userPhoto} alt={message.username} className="message-user-photo" />
          ) : (
            getUserIcon(message.userPhoto)
          )}
        </span>
        <div className="message-content-wrapper">
          <div className='message-summary'>
            {editMode ? (
              <form style={{ marginBottom: '0.5rem' }}>
                <input
                  type="text"
                  value={editText}
                  onChange={this.onChangeEditText}
                  style={{ width: '100%', marginBottom: '0.5rem' }}
                />
              </form>
            ) : (
              <span>
                <strong>{message.username}</strong>
                {message.organisation && (
                  <span className="message-org-badge">{message.organisation}</span>
                )}
                {' — '}
                {message.text}
                {message.editedAt && <span style={{ fontStyle: 'italic', opacity: 0.7, marginLeft: '0.5rem' }}>(edited)</span>}
              </span>
            )}
          </div>
          <div className='message-meta'>
            <span className="message-timestamp">{formatTimestamp(message.createdAt)}</span>
            {authUser.uid === message.userId && (
              <>
                <span className="message-separator"> • </span>
                {editMode ? (
                  <>
                    <a className="message-action" onClick={this.onSaveEditText}>
                      {t('messages.save_button')}
                    </a>
                    <span className="message-separator"> • </span>
                    <a className='message-action' onClick={this.onToggleEditMode}>
                      {t('messages.undo_button')}
                    </a>
                  </>
                ) : (
                  <>
                    <a className="message-action" onClick={this.onToggleEditMode}>
                      {t('messages.edit_button')}
                    </a>
                    <span className="message-separator"> • </span>
                    <a className="message-action message-action-danger" onClick={() => onRemoveMessage(message.uid, authUser)}>
                      {t('messages.trash_button')}
                    </a>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation(MessageItem);
